import { call, put, select, takeLatest } from 'redux-saga/effects'
import { setCutomSignatureOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { getServiceIdSelector } from '../../user/selectors'
import { SignaturesService } from '../../signatures/services/signatures.service'
import Logger from '../../../services/logger.service'
export function* getCustomSignatureOptions() {
  try {
    const serviceId = yield select(getServiceIdSelector)
    const signaturesService = new SignaturesService(serviceId)
    const response = yield call([signaturesService, signaturesService.getCustomSignatureOptions])
    const { entity } = response
    yield put(setCutomSignatureOptions(entity))
  } catch (e) {
    Logger.error(`getCustomSignatureOptions() error: ${e}`)
  }
}
export function* getCustomSignatureOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getCustomSignatureOptions)
}
